import React from "react";
import FooterReplicaList from "./FooterReplicaList";

function FooterReplica() {
  return (
    <>
      <div id="blur-prueba">
        <div className="botton-editar-pginews margin-boton-footer-pgi">
          <button className=" settings_button-pleno overlay-replica-button">
            {" "}
            <a href="/pgi/edit-footer">Editar Footer</a>
          </button>
        </div>
        <FooterReplicaList />
      </div>
    </>
  );
}

export default FooterReplica;
